import {HasNoteBaseMixin} from "../../widget/mixins/HasNoteBaseMixin.jsx";
import {PERSISTENCE_STATE_KEYS} from "../../../other/constants/PersistenceStateKeys.jsx";
import ClientsEditorBase from "./ClientsEditorBase.jsx";
import {DEEP_LINK_URL_KEYS} from "../../../other/constants/OtherKeys.jsx";

export default class ClientNotesTab extends HasNoteBaseMixin(ClientsEditorBase) {
  static get $name() {
    return "ClientNotesTab";
  }

  static get type() {
    return "clientnotestab";
  }

  get stateId() {
    return PERSISTENCE_STATE_KEYS.clientEditorNotesGridState;
  }

  get recordType() {
    return "clientId";
  }

  get deepLinkUrlKey() {
    return DEEP_LINK_URL_KEYS.client;
  }
}

ClientNotesTab.initClass();